import * as React from 'react';


export default class Recent extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">       
      <defs>
          <path id="prefix__a" d="M0.307 0.869L5.376 0.869 5.376 5.628 0.307 5.628z"/>
      </defs>
      <g fill="none" fillRule="evenodd">
          <path stroke="#727272" strokeLinecap="round" strokeLinejoin="round" d="M1.19 4.904c1-1.634 2.73-2.69 4.785-2.69 3.143 0 5.692 2.549 5.692 5.693 0 3.143-2.55 5.69-5.692 5.69-2.647 0-4.872-1.805-5.508-4.252" transform="translate(2 1)"/>
          <g transform="translate(2 1) translate(0 .065)">
              <mask id="prefix__b" fill="#fff">
                  <use xlinkHref="#prefix__a"/>
              </mask>
              <path fill="#727272" d="M5.376 4.867L5.25 4.092 1.435 4.719 1.089 0.868 0.307 0.939 0.729 5.628z" mask="url(#prefix__b)" transform="rotate(2 2.842 3.248)"/>
          </g>
          <path stroke="#727272" strokeLinecap="round" strokeLinejoin="round" d="M6.189 6.269L6.189 8.202 7.532 9.545" transform="translate(2 1)"/>
      </g>
      </svg>
    )
  }
}
